// extracted by mini-css-extract-plugin
export default {"customFooter":"footer_customFooter__B0eTA"};